import { render } from "./LegendPort.vue?vue&type=template&id=34584ba2"
import script from "./LegendPort.vue?vue&type=script&lang=js"
export * from "./LegendPort.vue?vue&type=script&lang=js"

import "./LegendPort.vue?vue&type=style&index=0&id=34584ba2&lang=css"
script.render = render

export default script